"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STARTTIME = exports.ENDTIME = exports.GREATER = exports.LOWER = void 0;
/*** Date Picker Constants ***/
exports.LOWER = 'lt:';
exports.GREATER = 'gt:';
exports.ENDTIME = 'T23:59:59.999Z';
exports.STARTTIME = 'T00:00:00.000Z';
